<template>
    <report-field-row   :field-id="field.key"
                        :label="field.label"
                        :description="field.description"
                        :error="error"
    >
        <date-time-picker   :id="field.key"
                            :model-value="modelValue"
                            :timezone="timezone"
                            :min-date="field.minDate"
                            :max-date="field.maxDate"
                            :view-mode="field.viewMode"
                            :format="field.format || 'YYYY-MM-DD HH:mm'"
                            :side-by-side="true"
                            @update:modelValue="$emit('update:modelValue', $event)"
        ></date-time-picker>
    </report-field-row>
</template>

<script>
import ReportFieldRow from "../ReportFieldRow.vue"
import DateTimePicker from "@/components/Reports/VueDatePicker.vue"

export default {
    name: "ReportDateField",
    components: {ReportFieldRow, DateTimePicker},
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: [Date, String],
            default: null,
        },
        field: {
            type: Object,
            required: true,
        },
        timezone: {
            type: String,
            default: 'America/New_York',
        },
        error: {
            type: String,
            default: null,
        },
    },
}
</script>
